export default "__VITE_ASSET__cb385d1b__"